var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.116 20.882h.086-32.868L27.497 8.218c.516-.49.817-1.186.817-1.923 0-.736-.3-1.39-.817-1.922l-1.68-1.596C25.302 2.287 24.57 2 23.796 2c-.775 0-1.464.286-2.023.777L.818 22.805A2.654 2.654 0 0 0 0 24.727c0 .737.301 1.391.818 1.923l20.954 20.027c.516.491 1.248.778 2.023.778.775 0 1.463-.287 2.023-.778l1.679-1.595c.516-.491.817-1.187.817-1.923s-.3-1.35-.817-1.882L14.205 28.573h32.911c1.55 0 2.884-1.268 2.884-2.782V23.5c0-1.432-1.334-2.618-2.884-2.618Z"
  })));
};

export default SvgArrowBack;